export { default } from './CustomerInformationView'
export * from './CustomerInformationView'
